export default "__VITE_ASSET__ac9a9e58__"